import React from 'react';
import { Spin } from 'antd';

//lazy wrapper for EditBillingInfo component
const LazyEditBillingInfo = React.lazy(() => import('./EditBillingInfo'));
export const AsyncEditBillingInfo: React.FC = () => (
	<React.Suspense fallback={<Spin />}>
		<LazyEditBillingInfo />
	</React.Suspense>
);
